import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { BadgesComponent } from './badges.component';
import { Routes, RouterModule } from '@angular/router';
import { BadgesRoutingModule } from './badges-routing.module';
import { EarnedComponent } from './earned/earned.component';
import { LeaderComponent } from './leader/leader.component';
import { AvailableComponent } from './available/available.component';
import { BottombarComponent } from '../components/bottombar/bottombar.component'; 
import { FooterComponentModule} from '../components/footer-component.module';
import { CampaignComponent } from './campaign/campaign.component';
import { SectionAdvertisementsComponent } from '../components/section-advertisements/section-advertisements.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BadgesRoutingModule,
    FooterComponentModule
  ],
  declarations: [BadgesComponent,EarnedComponent,LeaderComponent,CampaignComponent ,AvailableComponent, SectionAdvertisementsComponent]
})
export class BadgesModule {}
